import React, { Fragment } from 'react';
// import { inject, observer } from 'mobx-react';
import LineTable from './lineTable';


const LineSegment = (props) =>
    <Fragment>
        {props.league.map((item) => <LineTable key={item} sportName={props.name} id={item} />)}
    </Fragment>;
export default LineSegment;


// WEBPACK FOOTER //
// ./src/components/line/lineSegment.js